<template>
  <RangePicker
    dropdownClassName="coope-panel-calendar-container"
    allowClear
    :getCalendarContainer="getCalendarContainer"
    :align="{ offset: [-34, 28] }"
    style="width: auto"
    :open="visible"
    v-model="timeRange"
    @openChange="handleVisibleChange"
    @change="handleChange"
  >
    <span :class="labelClasses" @click="visible = true"
      ><span class="control-label">{{$t('common.Time')}}</span>
      <span class="arrow-icon" :class="{actived: visible}"><SvgIcon icon-class="arrow-left"/></span
    ></span>
    <div slot="renderExtraFooter" style="display: flex;justify-content: space-between">
      <div><span class="text-link" @click="timeRange = null">{{$t('common.Clear')}}</span></div>
      <div class="action-btns">
        <Button size="small" @click="visible = false">{{$t('common.Cancel')}}</Button>
        <Button size="small" type="primary" @click="handleOk">{{$t('common.Ok')}}</Button>
      </div>
    </div>
  </RangePicker>
</template>
<script>
import { DatePicker, Button } from 'ant-design-vue'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { pureMoment } from '@/utils/ops'

const RangePicker = DatePicker.RangePicker

export default {
  name: 'CoopePanelCalendarControl',
  props: {
    getCalendarContainer: {
      type: Function,
      required: false
    }
  },
  components: {
    RangePicker,
    Button
  },
  data() {
    return {
      visible: false,
      beginTime: null,
      endTime: null,
    }
  },
  computed: {
    ...mapState('coc', ['cocsQuery']),
    timeRange: {
      set(moments) {
        if (moments === null) {
          this.beginTime = null
          this.endTime = null
        } else {
          this.beginTime = pureMoment(moments[0])
          this.endTime = pureMoment(moments[1])
        }
      },
      get() {
        const { beginTime, endTime } = this
        if (beginTime === null || endTime === null) {
          return null
        }
        return [beginTime, endTime]
      }
    },
    labelClasses() {
      const { beginTime = null, endTime = null } = this.cocsQuery
      return (beginTime === null || endTime === null) ? 'coope-panel-control' : 'coope-panel-control actived'
    }
  },
  methods: {
    ...mapActions('coc', ['reloadCocs']),
    handleChange() {
      this.isClickoutSide = false
    },
    handleVisibleChange(visible) {
      if (visible) {
        const { beginTime, endTime } = this.cocsQuery
        if (beginTime && endTime) {
          this.timeRange = [moment(beginTime * 1000), moment(endTime * 1000)]
        } else {
          this.timeRange = null
        }

        this.isClickoutSide = false
      }

      setTimeout(() => { // changeValue发生在 changeVisible之后， 因此需要通过延时来模拟点击日历或者"外部"
        if (this.isClickoutSide) {
          this.visible = false
        } else if (this.visible) {
          this.isClickoutSide = true
        }
      }, 100)
    },
    handleOk() {
      const { beginTime, endTime } = this
      if (beginTime && endTime) {
        endTime.hour(23).minute(59).second(59)
        this.reloadCocs({ beginTime: beginTime.valueOf() / 1000, endTime: endTime.valueOf() / 1000 })
      } else {
        this.reloadCocs({ beginTime, endTime })
      }
      this.visible = false
    }
  }
}
</script>
<style scoped lang="less">
@import url(./control.less);
.action-btns {
  button + button {
    margin-left: 16px;
  }
}
</style>
